export const LOADER_PLAZAS_VACANTES         =        'LOADER_PLAZAS_VACANTES';
//export const LOADER_PLAZA_VACANTE           =        'LOADER_PLAZA_VACANTE';
//export const SAVE_LOADER_PLAZA_VACANTE      =        'SAVE_LOADER_PLAZA_VACANTE';
export const GET_PLAZAS_VACANTES            =        'GET_PLAZAS_VACANTES';
//export const GET_PLAZA_VACANTE              =        'GET_PLAZA_VACANTE';
//export const FORM_PLAZA_VACANTE_FALLA       =        'FORM_PLAZA_VACANTE_FALLA';
export const PLAZAS_VACANTES_FALLA          =        'PLAZAS_VACANTES_FALLA';
//export const PLAZA_VACANTE_FALLA            =        'PLAZA_VACANTE_FALLA';